<template>
  <div class="page">
    <div v-if="isLoading" class="loading">
      <div class="progress-icon full-screen"></div>
    </div>
    <div v-else>
      <div class="home-main-wrap" ref="pageWrap">
        <div
          class="right-section"
          :class="{
            'icon-view': !toggleNav,
            'right-section-transition': isNavbarResizing,
          }"
          :style="{ width: sectionWidth.right + '%' }"
          v-if="section != 'process-designer'"
        >
          <!-- Don't Remove This Otherwise Drag And Drop will not Work -->
          <div class="app-overlay" v-show="isDragging"></div>
          <NavbarTop
            :customUserNavItems="customDatabases"
            :activeDatabase="activeDatabase"
            v-if="section != 'process-designer' && !isFullScreen"
          />
          <div class="codelos-main-content">
            <div
              class="codelos-page-title-wrap font-aktiv-grotesk"
              v-if="section == 'data' && !noDatabases && !databaseNotFound"
            >
              <div class="codelos-page-title">
                <h4>{{ activeDatabase.caption }}</h4>
              </div>
              <div
                v-if="
                  activeDatabase.access_level != 'read' &&
                  activeDatabase.type != 'loadprofile'
                "
                class="create-new-database"
              >
                <div
                  class="add-new-button"
                  @click="togglePlusBtn"
                  ref="plusButton"
                  v-b-tooltip.hover.left
                  title="Datensatz hinzufügen"
                >
                  Neu
                  <i
                    v-if="activeDatabase?.type !== 'timetrigger'"
                    class="fas fa-chevron-down btn"
                    @click.stop="toggleUploadFile"
                  ></i>
                </div>
              </div>
            </div>
            <div
              :class="{
                'load-profile-list':
                  db.type == 'loadprofile' && section == 'data',
                'custom-database-list':
                  section == 'data' && db.type != 'loadprofile',
                'loader-position':
                  section == 'data' && db.name == activeDatabase.name,
              }"
              v-for="db in customDatabases"
              :key="db.name"
            >
              <LoadProfileList
                v-if="
                  db.type == 'loadprofile' &&
                  section == 'data' &&
                  db.name == activeDatabase.name
                "
                :key="db.name"
                :database="db"
                :activeDatabase="activeDatabase.name"
                :itemID="itemID"
                :isNewDataTypeModalVisible="isNewDataTypeModalVisible"
              />

              <CustomDatabasePage
                v-else-if="section == 'data' && db.name == activeDatabase.name"
                :key="`customlist-${db.name}-new1`"
                :database="db"
                :activeDatabase="activeDatabase.name"
                :itemID="itemID"
                :isNewDataTypeModalVisible="isNewDataTypeModalVisible"
                @setFilterToDatabaseSchema="setFilterToDatabaseSchema"
                ref="customListRef"
              />
            </div>
            <CustomListFullScreen
              v-if="section === 'list-view-custom'"
              :activeDatabase="activeDatabase.name"
              :database="activeDatabase"
            />
            <ProcessListPage v-if="['flows', 'preview'].includes(section)" />
            <NoDatabases v-if="noDatabases && section == 'data'" />
            <PageNotFound
              class="home-database-not-found"
              v-if="databaseNotFound"
              :isBackButtonVisible="false"
            />
          </div>
        </div>
        <WorkFlowPage
          v-if="section == 'process-designer'"
          :processID="processID"
          :databases="customDatabases"
        />
        <NavbarLeft
          ref="navbarLeft"
          :customUserNavItems="customDatabases"
          :activeDatabase="activeDatabase"
          :isLeftNavbarVisible="toggleNav"
          :leftNavbarWidth="leftNavbarWidth"
          :toggleNav="toggleNav"
          :sectionWidthLeft="sectionWidth.left"
          :iconView="iconView"
          :navbarExpandCollapse="navbarExpandCollapse"
          @toggleNewDataType="toggleNewDataType"
          @toggleShareDatabase="toggleShareDatabase"
          @toggleRemoveDatabase="toggleRemoveDatabase"
          @toggleLeaveDatabase="toggleLeaveDatabase"
          @toggleEditDatabaseSchema="toggleEditDatabaseSchema"
          @toggleLeftNavbar="toggleLeftNavbar"
          @toggleCopyDatabase="closeNewDataType"
          @changeDataBaseOrder="changeDataBaseOrder"
          @getCustomDatabases="getCustomDatabases"
          @updateNavWidth="updateNavWidth"
          @toggleDatabaseSettingModal="toggleDatabaseSettingModal"
          v-if="isSectionAllowed && !isFullScreen"
          @toggleIconView="toggleIconView"
        />
        <div
          class="navbar-adjustment-div"
          v-if="isSectionAllowed && !toggleNav"
        ></div>
      </div>
      <tableShareModal
        v-if="isShareTableModalVisible"
        :database="activeDatabase"
        @close="toggleShareDatabase"
      />
      <NewDataType
        v-if="isNewDataTypeModalVisible"
        class="modal-window"
        :tableList="customDatabasesNames"
        :editTable="editTable"
        :databaseMeta="activeDatabase"
        :loading="loading"
        @close="closeNewDataType"
        @toogleLoading="toogleLoading"
      />
      <removeConfirmationModal
        v-if="confirmationModal.isVisible"
        class="modal-window"
        :id="confirmationModal.id"
        :name="confirmationModal.name"
        :resourceType="confirmationModal.resourceType"
        :actionType="confirmationModal.actionType"
        @close="toggleConfirmationModal"
        @confirmRemove="removeDatabase"
        @confirmLeave="leaveDatabase"
      />
      <databaseSettingsModal
        v-if="isDatabaseSettingModalVisible"
        :database="activeDatabase"
        @close="toggleDatabaseSettingModal"
        @updateDatabaseSetting="updateDatabaseSetting"
      />
    </div>
  </div>
</template>

<script>
import NavbarTop from './NavbarTop.vue';
import NavbarLeft from './NavbarLeft.vue';
import LoadProfileList from './LoadProfileList.vue';
import NoDatabases from './NoDatabases.vue';
import NewDataType from '../components/NewDataType.vue';
import tableShareModal from './modals/tableShareModal.vue';
import removeConfirmationModal from './modals/removeConfirmModal.vue';
import databaseSettingsModal from './modals/databaseSettingsModal.vue';
import store from '../store/store';
import { mapGetters, mapActions } from 'vuex';
import { deleteDatabaseApi, leaveDatabaseApi } from '../services/userTable';
import CustomListFullScreen from './CustomListFullScreen.vue';
import CustomDatabasePage from '../pages/CustomDatabasePage.vue';
import WorkFlowPage from '../pages/WorkFlowPage.vue';
import ProcessListPage from '../pages/ProcessListPage.vue';
import PageNotFound from './PageNotFound.vue';

export default {
  name: 'Home',
  data() {
    return {
      iconView: true,
      isComponentLoading: true,
      isNewDataTypeModalVisible: false,
      isShareTableModalVisible: false,
      confirmationModal: {
        id: null,
        name: null,
        actionType: null,
        isVisible: false,
        resourceType: 'database',
      },
      editTable: false,
      customDatabases: [],
      leftNavbarWidth: 420,
      toggleNav: true,
      isRefreshingOnNavbar: false,
      isDatabaseSettingModalVisible: false,
      loading: false,
    };
  },
  props: {
    section: String,
    database: String,
    processID: String,
    itemID: String,
  },
  methods: {
    ...mapActions(['checkTokenRefresh']),
    navbarExpandCollapse() {
      if (this.toggleNav) {
        return false;
      } else {
        return this.iconView;
      }
    },
    togglePlusBtn() {
      setTimeout(() => {
        this.$refs.customListRef[0].togglePlusBtn();
      }, 10);
    },
    toggleUploadFile() {
      setTimeout(() => {
        this.$refs.customListRef[0].toggleUploadFile();
      }, 10);
    },
    toggleLeftNavbar(toggleLeftNav) {
      this.toggleNav = toggleLeftNav;
    },
    updateNavWidth(event) {
      this.leftNavbarWidth = event;
    },
    getFrontendTableNameFormat(name) {
      return name.slice(name.indexOf('_') + 1);
    },

    async getCustomDatabases(copiedDatabase) {
      try {
        this.isRefreshingOnNavbar = true;
        await this.$store.dispatch('fetchUserDataBase', copiedDatabase);
        this.isRefreshingOnNavbar = false;
        this.databaseList;
        for (let e of this.databaseList) {
          if (!e.hasOwnProperty('layout'))
            e.layout =
              '{"tabs":[{"id":0,"rows":[{"id":0,"cols":[{"id":0}]}]}]}';
          if (!e.hasOwnProperty('iconType')) e.linkType = 'icon';
          this.customDatabases = this.databaseList;
          // Push to db if no query params
          if (!this.section || (this.section == 'data' && !this.database)) {
            this.setDatabaseRoute();
          }
        }
        this.isComponentLoading = false;
      } catch (error) {
        this.isComponentLoading = false;
        this.isRefreshingOnNavbar = false;
      }
    },
    toggleShareDatabase: function () {
      this.isShareTableModalVisible = !this.isShareTableModalVisible;
    },
    toggleRemoveDatabase: function (database) {
      this.$set(this.confirmationModal, 'id', database.name);
      this.$set(this.confirmationModal, 'name', database.caption);
      this.$set(this.confirmationModal, 'actionType', 'remove');
      this.toggleConfirmationModal();
    },
    toggleLeaveDatabase: function (database) {
      this.$set(this.confirmationModal, 'id', database.name);
      this.$set(this.confirmationModal, 'name', database.caption);
      this.$set(this.confirmationModal, 'actionType', 'leave');
      this.toggleConfirmationModal();
    },
    toggleEditDatabaseSchema: function () {
      this.editTable = true;
      this.toggleNewDataType();
    },
    toggleConfirmationModal: function () {
      this.$set(
        this.confirmationModal,
        'isVisible',
        (this.confirmationModal.isVisible = !this.confirmationModal.isVisible)
      );
    },
    toggleDatabaseSettingModal() {
      this.isDatabaseSettingModalVisible = !this.isDatabaseSettingModalVisible;
    },
    async handleDatabaseOnLeaveOrDelete(response, name) {
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.ResponseMetadata
      ) {
        this.customDatabases = this.customDatabases.filter(
          (e) => e.name !== name
        );
        this.$store.commit('SET_DATABASE_LIST', this.customDatabases);
        let database;

        // Change to another DB
        if (this.customDatabases.length > 0) {
          database = this.customDatabases[0];
          const isTreeView =
            database?.caption && database?.caption?.split(' - ').length > 1;

          if (isTreeView) {
            const path = database?.caption?.split(' - ');
            this.$refs.navbarLeft?.openTreeNode(path[0]);
          }
        } else {
          database = { name: 'noDatabases' };
        }
        this.$router.push({
          path: '/',
          query: { section: 'data', database: database.name },
        });

        await this.$store.dispatch('filterSettingBasedOnDatabases', {
          deletedDatabase: name,
        });
      }
    },
    removeDatabase: async function (name) {
      try {
        const response = await deleteDatabaseApi(name);
        await this.handleDatabaseOnLeaveOrDelete(response, name);
      } catch (error) {}
    },
    leaveDatabase: async function (name) {
      try {
        let policyId = this.customDatabases.find((e) => e.name == name)[
          'policy_id'
        ];

        const response = await leaveDatabaseApi(name, {
          policy_id: policyId,
        });
        await this.handleDatabaseOnLeaveOrDelete(response, name);
      } catch (error) {}
    },
    toggleNewDataType: function () {
      document.body.classList.add('modal-open');
      this.isNewDataTypeModalVisible = !this.isNewDataTypeModalVisible;
    },
    closeNewDataType: async function (copiedDatabase = null) {
      try {
        document.body.classList.remove('modal-open');

        if (copiedDatabase) {
          copiedDatabase = {
            ...copiedDatabase,
            copiedDatabaseName: copiedDatabase.name,
            databaseName: copiedDatabase.databaseName,
          };
          await this.getCustomDatabases(copiedDatabase);
          const databaseName = copiedDatabase?.copiedDatabaseName;
          if (databaseName) {
            const updatedUserSettings = {
              settings: { selectedDatabase: databaseName },
            };
            this.$store.dispatch('putUserSettings', updatedUserSettings);
            await this.$router.push({
              path: '/',
              query: { section: 'data', database: databaseName },
            });
          }
        }
      } catch (error) {
        //
      } finally {
        this.editTable = false;
        this.isNewDataTypeModalVisible = false;
        this.loading = false;
      }
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    changeDataBaseOrder(dragIdx, dropIdx) {
      const dragEl = this.customDatabases.splice(dragIdx, 1)[0];
      this.customDatabases.splice(dropIdx, 0, dragEl);
    },
    updateDatabaseSetting(databaseName, confirmDelete, showSeconds) {
      this.customDatabases = this.customDatabases.map((database) =>
        database.name === databaseName
          ? { ...database, confirmDelete, showSeconds }
          : database
      );
    },
    setFilterToDatabaseSchema(filters) {
      this.customDatabases.forEach((database) => {
        if (database.name === this.database) {
          database.filters = JSON.stringify(filters);
        }
      });
    },
    setDatabaseRoute() {
      let db;
      if (this.userSettings && this.userSettings.selectedDatabase)
        db = this.userSettings.selectedDatabase;
      else if (
        this.userSettings &&
        !this.userSettings.selectedDatabase &&
        this.databaseList.length > 0
      )
        db = this.databaseList[0].name;
      else db = 'noDatabases';
      this.$router.push({
        path: '/',
        query: { section: 'data', database: db },
      });
    },
    toggleIconView(value) {
      this.iconView = value;
    },
    toogleLoading(toggle) {
      this.loading = toggle;
    },
  },
  created() {
    this.getCustomDatabases();
    if (this.userSettings) {
      this.leftNavbarWidth =
        typeof this.userSettings.leftNavbarWidth === 'number' &&
        this.userSettings.leftNavbarWidth < 420 &&
        this.userSettings.leftNavbarWidth > 210
          ? this.userSettings.leftNavbarWidth
          : 420;
      this.toggleNav = this.userSettings.isShowLeftNavbar;
      this.iconView = !this.toggleNav;
    }
  },

  updated() {
    this.$nextTick(() => {
      this.checkTokenRefresh();
    });
  },

  watch: {
    '$route.query'(newQueryParams) {
      if (
        !Object.keys(newQueryParams)?.length ||
        (this.section == 'data' && !this.database)
      ) {
        this.setDatabaseRoute();
      } else if (
        !this.section ||
        ![
          'data',
          'list-view-custom',
          'flows',
          'preview',
          'process-designer',
        ].includes(this.section)
      ) {
        if ('process' in newQueryParams) {
          this.$router.push({
            path: '/',
            query: {
              section: 'process-designer',
              process: newQueryParams.process,
            },
          });
        } else {
          this.setDatabaseRoute();
        }
      } else if (
        this.section === 'process-designer' &&
        !newQueryParams['process']
      ) {
        this.$router.push({
          path: '/',
          query: {
            section: 'flows',
          },
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      isDragging: 'getDatabaseDragging',
      getAccessTokenExpiry: 'getAccessTokenExpiry',
      isNavbarResizing: 'isNavbarResizing',
    }),
    isFullScreen() {
      return ['list-view-custom'].includes(this.section);
    },
    user() {
      return store.state.user;
    },
    customDatabasesNames() {
      return this.customDatabases.map((e) => e.name);
    },
    noDatabases() {
      return this.customDatabases.length < 1 && !this.isFlowListVisible;
    },
    databaseNotFound() {
      return this.activeDatabase.name === 'databaseNotFound';
    },
    activeDatabase() {
      let db = this.database;
      let dbs = this.customDatabases;
      let filteredDbs = dbs.filter((e) => e.name == db);

      if (filteredDbs.length == 1) return filteredDbs[0];
      else {
        if (dbs.length > 0) {
          if (db && !filteredDbs.length) {
            return { name: 'databaseNotFound' };
          }
          return dbs[0];
        } else return { name: 'noDatabases' };
      }
    },
    shiftToRight() {
      let sections = ['flows', 'process-designer'];
      if (this.toggleNav === false) {
        return '';
      } else {
        return !sections.includes(this.section);
      }
    },
    isLoading() {
      return this.$store.state.isLoading || this.isComponentLoading;
    },
    userSettings() {
      return store.state.userSettings;
    },
    screenWidth() {
      return window.screen.width;
    },
    sectionWidth() {
      const pc = this.screenWidth / 100;
      const width = (this.screenWidth - this.leftNavbarWidth) / pc;
      return {
        left: 100 - width,
        right: width,
        screen: this.screenWidth,
        pc: pc,
        width: width,
      };
    },
    isSectionAllowed() {
      return !['flows', 'preview', 'process-designer'].includes(this.section);
    },
  },
  components: {
    NavbarTop,
    NavbarLeft,
    LoadProfileList,
    NoDatabases,
    NewDataType,
    tableShareModal,
    removeConfirmationModal,
    databaseSettingsModal,
    CustomListFullScreen,
    WorkFlowPage,
    CustomDatabasePage,
    PageNotFound,
    ProcessListPage,
  },
};
</script>

<style>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.main-content {
  height: calc(100vh - 120px);
  position: relative;
}
.main-content,
.main-content * {
  box-sizing: border-box;
}
.sign-out {
  width: 160px;
  margin: 0 auto;
}

.page {
  height: 100%;
  background-color: #f9f9fb;
  width: 100%;
  overflow: hidden;
  margin: 0 !important;
}

.round-button::selection {
  background: transparent;
}

.loading {
  height: 100%;
  background-color: #f9f9fb;
}

.progress-icon.full-screen {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 50%;
  width: 70px;
  height: 70px;
}

.progress-icon.full-screen:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.right-section {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  transition: all 200ms ease-in-out;
}

.collapse {
  /* width: 0 !important; */
}

/*Updated Loader*/
.loading {
  height: 100%;
  background-color: #f9f9fb;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.progress-icon.full-screen {
  position: absolute;
  left: 0;
  -webkit-transform: translate(-50%);
  transform: translateY(-50%);
  top: 50%;
  width: 100%;
  height: 70px;
  margin: 0 auto;
}

.progress-icon.full-screen:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.home-main-wrap {
  display: flex;
  flex-direction: row-reverse;
  min-height: 100vh;
  width: 100%;
}

.app-overlay {
  height: 100%;
  width: 100%;
  z-index: 99;
  position: absolute;
  display: block;
}

/* new UI */
.codelos-main-content {
  padding: 0 36px 0 54px;
  background-color: #fff;
  height: calc(100dvh - 90px);
}

.codelos-main-content,
.codelos-main-content * {
  box-sizing: border-box;
}

.codelos-page-title h4 {
  color: #333343;
  font-size: 36px;
}
.codelos-page-title-wrap .add-new-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 6px;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 114px;
  font-size: 23px;
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  font-family: 'AktivGroteskMedium';
}
.codelos-page-title-wrap .add-new-button .btn {
  color: white;
  font-size: 18px;
  opacity: 0.5;
  padding: 8px;
  padding-right: 0px;
}
.codelos-page-title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.loader-position {
  position: relative;
  min-height: calc(100% - 150px);
}
.codelos-page-title-wrap .add-new-button i {
  border: none;
}
.codelos-page-title-wrap .add-new-button i:hover {
  opacity: 1;
}
</style>

<style scoped>
.page .codelos-main-content ::v-deep .home-database-not-found.error-page {
  padding: 0 !important;
  height: 100% !important;
}
.page .home-main-wrap .navbar-adjustment-div {
  width: 107px;
}
@media only screen and (max-width: 576px) {
  .codelos-main-content {
    padding: 0px 15px !important;
  }
}

.page .right-section-transition {
  transition: none !important;
}
</style>
